var msInOneHour = 60 * 60 * 1000;
var msInOneDay = 24 * msInOneHour;
export function countDays(time) {
    return (Date.now() - time) / msInOneDay;
}
export function countHours(time) {
    return (Date.now() - time) / msInOneHour;
}
